import { VideoPlayer, detectPlayerType } from './video-player.interface';
import { NativeVideoPlayer } from './native-video-player';
import { VimeoVideoPlayer } from './vimeo-video-player';
import { YouTubeVideoPlayer } from './youtube-video-player';
import { DailymotionVideoPlayer } from './dailymotion-video-player';

export function createVideoPlayer(url: string): VideoPlayer {
    switch (detectPlayerType(url)) {
        case 'vimeo':       return new VimeoVideoPlayer();
        case 'youtube':     return new YouTubeVideoPlayer();
        case 'dailymotion': return new DailymotionVideoPlayer();
        default:            return new NativeVideoPlayer();
    }
}
